export default {
  errorName: "Naziv je obavezno polje.",
  errorSymbol: "Simbol je obavezno polje.",
  errorDescription: "Opis je obavezno polje.",
  errorType: "Tip je obavezno polje.",
  errorUpdateProfile: "Morate promeniti barem jedno polje",
  errorDate: "Datum je obavezno polje.",
  errorCategory: "Kategorija je obavezno polje.",
  errorAmount: "Iznos je obavezno polje.",
  errorCurrency: "Valuta je obavezno polje.",
  enterName: "Unesi naziv",
  enterSymbol: "Unesi simbol",
  enterDescription: "Unesi opis",
  enterType: "Izaberi tip",
  enterCategory: "Izaberi kategoriju",
  enterAmount: "Unesi iznos",
  enterCurrency: "Izaberi valutu",
  enterDate: "Izaberi datum",
  add: "Dodaj",
  delete: "Obriši",
  edit: "Izmeni",
  export: "Izvezi",
  filters: "Filteri",
  actions: "Akcije",
  close: "Zatvori",
  yes: "Da",
  no: "Ne",
  currency: "Valuta",
  currencyPageSubtitle: "Ovde možete podesiti valute koje želite koristiti u sistemu",
  name: "Naziv",
  firstName: "Ime",
  lastName: "Prezime",
  symbol: "Simbol",
  description: "Opis",
  type: "Tip",
  category: "Kategorija",
  calculateForGross: "Uvrsti u kalkulaciju za GROSS profit",
  calculateForNet1: "Uvrsti u kalkulaciju za Profit 1",
  calculateForNet2: "Uvrsti u kalkulaciju za Profit 2",
  confirmationModalTitle: "Potvrda",
  confirmationModalMessage: "Da li ste sigurni da želite da izvšite ovu akciju?",
  save: "Sačuvaj",
  income: "Prihod",
  totalIncomes: "Ukupni prihodi",
  averageIncomes: "Prosečni prihodi",
  viewIncomes: "Vidi prihode",
  incomesDistribution: "Raspodela prihoda",
  incomesDistributionByType: "Raspodela prihoda (prema tipovima)",
  incomesDistributionByCategory: "Raspodela prihoda (prema kategorijama)",
  incomeType: "Tip prihoda",
  incomeTypePageSubtitle: "Ovde možete podesiti tipove prihoda koje želite koristiti u sistemu",
  incomeCategory: "Kategorija prihoda",
  incomeCategoryPageSubtitle: "Ovde možete podesiti kategorije prihoda koje želite koristiti u sistemu",
  cost: "Rashod",
  totalCosts: "Ukupni rashodi",
  averageCosts: "Prosečni rashodi",
  viewCosts: "Vidi rashode",
  costsDistribution: "Raspodela rashoda",
  costsDistributionByType: "Raspodela rashoda (prema tipovima)",
  costsDistributionByCategory: "Raspodela rashoda (prema kategorijama)",
  costType: "Tip rashoda",
  costTypePageSubtitle: "Ovde možete podesiti tipove troška koje želite koristiti u sistemu",
  costCategory: "Kategorija rashoda",
  costCategoryPageSubtitle: "Ovde možete podesiti kategorije troška koje želite koristiti u sistemu",
  dashboard: "Pregled",
  dashboardPageSubtitle: "Pregled vašeg kompletnog poslovanja",
  incomes: "Prihodi",
  incomesPageSubtitle: "Pregled vaših prihoda",
  costs: "Rashodi",
  costsPageSubtitle: "Pregled vaših rashoda",
  selectPlaceholder: "Izaberi",
  account: "Profil",
  accountDetails: "Detalji profila",
  security: "Zaštita",
  email: "Email",
  changePassword: "Promena lozinke",
  oldPassword: "Stara lozinka",
  newPassword: "Nova lozinka",
  confirmPassword: "Potvrdi lozinku",
  enterOldPassword: "Unesi staru lozinku",
  enterNewPassword: "Unesi novu lozinku",
  enterConfirmPassword: "Potvrdi novu lozinku",
  errorOldPassword: "Stara lozinka je obavezno polje.",
  errorNewPassword: "Nova lozinka je obavezno polje.",
  errorConfirmPassword: "Potvrda nove lozinke je obavezno polje.",
  errorConfirmMismatchPassword: "Potvrđena lozinka se razlikuje od nove lozinke.",
  apiBadRequestError: "Proverite da li su poslati parametri u ispravno formatu.",
  apiNotAuthorizedError: "Molim Vas ulogujte se ponovo.",
  apiForbiddenError: "Nemate privilegije da pristupite željenom resursu.",
  apiNotFoundError: "Zahtevani resurs nije pronađen.",
  apiConflictError: "Ne možete izvršiti željenu akciju na izabranom resursu.",
  apiInternalServerError: "Došlo je do neočekivane greške. Molim Vas pokušajte kasnije.",
  apiLoginError: "Lozinka ili email adresa su pogrešni.",
  resetPasswordLinkError: "Link za resetovanje lozinke je pogrešan.",
  info: "Info",
  january: "Januar",
  february: "Februar",
  march: "Mart",
  april: "April",
  may: "Maj",
  june: "Jun",
  july: "Jul",
  august: "Avgust",
  september: "September",
  october: "Oktobar",
  november: "Novembar",
  december: "Decembar",
  currentMonth: "Trenutni mesec",
  success: "Potvrda",
  error: "Greška",
  profileUpdateSuccess: "Uspešno ste ažurirali profil.",
  passwordUpdateSuccess: "Uspešno ste ažurirali lozinku.",
  amount: "Ukupan iznos",
  date: "Datum",
  searchCosts: "Pretraži rashode",
  search: "Pretraži",
  resetSearch: "Poništi pretragu",
  costsSearchResults: "Pronađeno {0} rashoda od {1} do {2}",
  total: "Ukupno: {0}",
  searchIncomes: "Pretraži prihode",
  incomesSearchResults: "Pronađeno {0} prihoda od {1} do {2}",
  net1: "Profit 1",
  net2: "Profit 2",
  viewReport: "Vidi izveštaj",
  reviewForPeriod: "Pregled za period od {0} do {1}",
  noData: "Nema podataka",
  reports: "Izveštaji",
  quarterlyReport: "Kvartalni izveštaj",
  quarterlyReportSubtitle: "Uporedi prihode i rashode kvartalno",
  comparativeReport: "Uporedni izveštaj",
  comparativeReportSubtitle: "Uporedi prihode i rashode za bilo koja dva meseca",
  login: "Prijava",
  logout: "Odjava",
  enterEmail: "Unesi email adresu",
  errorEmail: "Email adresa je obavezno polje.",
  password: "Lozinka",
  enterPassword: "Unesi lozinku",
  errorPassword: "Lozinka je obavezno polje.",
  forgotPassword: "Zaboravljena lozinka?",
  passwordRecovery: "Resetovanje lozinke",
  passwordForgotten: "Zaboravljena lozinka",
  resetPassword: "Resetuj lozinku",
  returnToLogin: "Vrati se na prijavu",
  forgotPasswordDescription: "Unesi email adresu i mi ćemo ti poslati link za resetovanje lozinke.",
  forgotPasswordEmailSent: "Email sa linkom za resetovanje lozinke je poslat.",
  forgotPasswordRequest: "Pošalji zahtev",
  byType: "Prema tipovima",
  byCategory: "Prema kategorijama",
  quarter1: "Prvi kvartal",
  quarter2: "Drugi kvartal",
  quarter3: "Treći kvartal",
  quarter4: "Četvrti kvartal",
  overview: "Pregled",
  inDetail: "Detaljno",
  average: "Prosečno",
  permissionsAlert: "Nemate privilegije da pristupite ovoj stranici, molimo Vas kontaktirajte administratora.",
  percentageOfIncome: "Procenat u odnosu na prihode",
  percentageOfCost: "Procenat u odnosu na rashode",
  nominalValue: "Nominalna vrednost",
  defaultIncomes: "Osnovni prihodi",
  otherIncomes: "Ostali prihodi",
};
